import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function PizzaIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.8629 22.1354C17.8629 23.1425 18.4078 24.0521 19.2687 24.5596L22.225 19.6484C21.7934 19.4181 21.3057 19.2951 20.8038 19.2951C19.1822 19.2951 17.8629 20.5693 17.8629 22.1354Z"
        fill="currentColor"
      />
      <path
        d="M10.8014 20.1612C12.4045 19.9103 13.4934 18.4517 13.2336 16.9034C12.9737 15.3552 11.4634 14.3035 9.8603 14.5545C8.25718 14.8055 7.16827 16.2641 7.42815 17.8123C7.68803 19.3606 9.19828 20.4122 10.8014 20.1612Z"
        fill="currentColor"
      />
      <path
        d="M29.9656 7.02266C29.8496 6.37177 29.4485 5.80346 28.8651 5.46341C24.9781 3.1976 20.5294 2 16 2C11.4706 2 7.02192 3.1976 3.13489 5.46341C2.55148 5.80346 2.15041 6.37183 2.03444 7.02266C1.91762 7.67831 2.10109 8.34916 2.53767 8.86323C3.28834 9.74703 4.58025 9.95457 5.60963 9.35656C8.74961 7.53263 12.3425 6.56854 16 6.56854C19.6575 6.56854 23.2504 7.53263 26.3904 9.35656C27.4197 9.95441 28.7117 9.74703 29.4623 8.86323C29.899 8.34916 30.0824 7.67831 29.9656 7.02266Z"
        fill="currentColor"
      />
      <path
        d="M25.004 10.4702C24.7801 12.7377 22.7974 14.5173 20.3918 14.5173C17.8367 14.5173 15.758 12.5097 15.758 10.0421C15.758 9.39807 15.8992 8.77518 16.1652 8.2049C16.1101 8.20441 16.0551 8.20353 15.9999 8.20353C12.6498 8.20353 9.35867 9.08673 6.48211 10.7577C5.94689 11.0686 5.34984 11.2553 4.73851 11.3102L6.67894 14.6123C7.52758 13.5607 8.85017 12.8824 10.3345 12.8824C12.8896 12.8824 14.9683 14.89 14.9683 17.3576C14.9683 19.6176 13.2243 21.4906 10.968 21.79L15.9938 30L18.4178 25.9731C17.0424 25.1773 16.1699 23.7344 16.1699 22.1354C16.1699 19.6678 18.2487 17.6602 20.8038 17.6602C21.6072 17.6602 22.3874 17.8609 23.0756 18.2352L27.2448 11.3091C26.6393 11.2523 26.0482 11.0658 25.5178 10.7577C25.348 10.659 25.1767 10.5634 25.004 10.4702Z"
        fill="currentColor"
      />
      <path
        d="M23.3328 10.0421C23.3328 9.91421 23.3232 9.78695 23.3057 9.66106C21.6343 8.96516 19.8654 8.51175 18.0571 8.31548C17.6644 8.80881 17.4509 9.40961 17.4509 10.0421C17.4509 11.6082 18.7702 12.8824 20.3918 12.8824C22.0135 12.8824 23.3328 11.6082 23.3328 10.0421Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
